<template>
  <el-dialog
    title="Source Details"
    :visible="visible"
    width="500px"
    top="10vh"
    :modal="false"
    :append-to-body="true"
    @close="$emit('closeModal')"
    class="p-[10px] keyreply-citation-modal"
  >
    <div class="keyreply-source-content">
      <h3 class="keyreply-source-title">{{ citation.source }}</h3>

      <el-card class="keyreply-quote-card" shadow="never">
        <blockquote class="keyreply-quote">
          {{ shouldShowFullQuote ? citation.snippet : blockQuote }}
          <!-- Read more -->
          <el-button
            type="text"
            @click="shouldShowFullQuote = !shouldShowFullQuote"
            v-if="citation.snippet.length > 200"
          >
            {{ shouldShowFullQuote ? "Read Less" : "Read More" }}
          </el-button>
        </blockquote>
      </el-card>

      <div class="keyreply-confidence-section">
        <span>Confidence:</span>
        <el-progress :percentage="citationConfidence" class="flex-1 mx-[10px] my-0" />
      </div>

      <el-button
        v-if="showFullSource"
        type="primary"
        icon="el-icon-link"
        class="keyreply-view-button"
        @click="onViewSource"
        plain
      >
        View Full Source
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    citation: {
      type: Object,
      default: () => {},
    },
    showFullSource: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shouldShowFullQuote: false,
    };
  },
  name: "SourceDetails",
  methods: {
    onViewSource() {
      window.open(this.citation.documentUrl, "_blank");
    },
  },
  computed: {
    citationConfidence() {
      return parseFloat((this.citation.relevance * 100).toFixed(1));
    },
    updatedYear() {
      return dayjs(this.citation.uploadedAt).format("YYYY");
    },
    blockQuote() {
      // Cut into 200 characters
      const words = this.citation.snippet.split(" ");
      let quote = "";
      let wordCount = 0;
      if (this.shouldShowFullQuote) {
        return this.citation.snippet;
      }
      for (let i = 0; i < words.length; i++) {
        if (wordCount >= 200) {
          break;
        }
        quote += words[i] + " ";
        wordCount += words[i].length;
      }
      return quote;
    },
  },
};
</script>

<style scoped>
.keyreply-citation-modal {
  font-family: "Montserrat", sans-serif;
}
.keyreply-source-title {
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 18px;
}

.keyreply-source-meta {
  color: #777;
  font-size: 16px;
  margin-bottom: 16px;
}

.keyreply-quote-card {
  background: #f9fafb;
  border-left: 4px solid #409eff;
  margin-bottom: 20px;
}

.keyreply-quote {
  color: #333;
  margin: 0;
  font-size: 16px;
}

.keyreply-confidence-section {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.keyreply-confidence-percent {
  color: #333;
}

.keyreply-view-button {
  width: 100%;
  background-color: rgb(78, 108, 206);
  color: #fff;
  border-color: rgb(78, 108, 206);
}

.keyreply-view-button:hover {
  background-color: rgb(78, 108, 206);
  color: #fff;
  border-color: rgb(78, 108, 206);
}
</style>

<style>
.keyreply-citation-modal .el-dialog__body {
  padding: 10px 20px !important;
}
</style>
